import type { ReactNode } from 'react';
import { Link } from 'react-router';

export interface FooterLink {
  to: string;
  text: string;
}

/** idsk/components/footer (meta section: support links and custom text). */
export function Footer({ links, visuallyHiddenTitle, meta, copy }: { links: FooterLink[]; visuallyHiddenTitle: string; meta?: ReactNode; copy?: ReactNode }) {
  return (
    <footer className="idsk-footer">
      <div className="govuk-width-container">
        <div className="idsk-footer__meta">
          <div className="idsk-footer__meta-item idsk-footer__meta-item--grow">
            {copy && <span className="idsk-footer__licence-description">{copy}</span>}
            <h2 className="govuk-visually-hidden">{visuallyHiddenTitle}</h2>
            <ul className="idsk-footer__inline-list">
              {links.map((l) => (
                <li className="idsk-footer__inline-list-item" key={l.to}>
                  <Link className="idsk-footer__link" to={l.to}>
                    {l.text}
                  </Link>
                </li>
              ))}
            </ul>
            {meta && <div className="idsk-footer__meta-custom">{meta}</div>}
          </div>
        </div>
      </div>
    </footer>
  );
}
